<template>
  <div class="beneficary-customer-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <svg-icon icon-class="firewall" /> Beneficiary
      </div>

      <div>
        <data-tables
          v-loading="loading"
          :data="tableData"
          border
          style="width: 100%"
          size="mini"
          :page-size="20"
          :pagination-props="{
            background: true,
            pageSizes: [20, 50, 100, 200],
          }"
        >
          <el-table-column prop="memberCode" label="Member Code">
          </el-table-column>
          <el-table-column prop="projectName" label="Project">
          </el-table-column>
          <el-table-column
            prop="pendingBeneficiary"
            label="Pending"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="totalBeneficiary"
            label="Total Beneficiary"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="paymentuid"
            label="Actions"
            width="180"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="showDetail(scope.row.uid, scope.row.memberCode)"
              >
                Detail
              </el-button>
              <el-button
                type="danger"
                size="mini"
                @click="deleteItem(scope.row.uid)"
              >
                Remove
              </el-button>
            </template>
          </el-table-column>
        </data-tables>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getBeneficiaryCustomer, deleteBeneficiaryCustomerByUID } from "@/api/beneficiary-monitor";
export default {
  data() {
    return {
      loading: false,
      tableData: [],
    };
  },
  methods: {
    getBeneficiaryCustomer() {
      this.tableData = [];
      this.loading = true;
      getBeneficiaryCustomer().then(({ result, data, message }) => {
        this.loading = false;
        if (result) {
          this.tableData = data;
        }
      });
    },
    showDetail(uid, membercode) {
      this.$router.push({
        name: "FirewallBeneficiaryDetail",
        params: {
          membercode: membercode,
          beneficiaryid: uid,
        },
      });
      //window.open(route.href, '_blank');
    },
    deleteItem(uid) {
      this.$confirm(
        "Are you sure you want to delete this Customer, Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          deleteBeneficiaryCustomerByUID(uid).then(({ result, message }) => {
            if (result) {
              this.getBeneficiaryCustomer();
              this.$notify({
                title: "Success",
                message: `Delete beneficiary successfully`,
                type: "success",
                duration: 2000,
              });
            } else {
              this.$notify({
                title: "Error",
                message: message,
                type: "error",
                duration: 2000,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
  },
  mounted() {
    this.getBeneficiaryCustomer();
  },
};
</script>

<style lang="scss">
</style>